var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "trails",
              label: _vm.$t(_vm.title_trails),
              icon: "fal fa-sign"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "trails" }
            },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c("div", { class: _vm.filterClass }, [_c("filter-trail")], 1),
                _c("div", { class: _vm.contentClass }, [
                  _c("div", { staticClass: "row gutter-md" }, [
                    _vm.banners.length > 0
                      ? _c(
                          "div",
                          { staticClass: "col-12 desktop-only" },
                          [
                            _c(
                              "q-carousel",
                              {
                                staticClass: "text-white",
                                attrs: {
                                  height: "200px",
                                  infinite: "",
                                  autoplay: ""
                                }
                              },
                              _vm._l(_vm.banners, function(banner, index) {
                                return _c("q-carousel-slide", {
                                  key: index,
                                  attrs: { "img-src": banner.image_desktop }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.banners.length > 0 && _vm.showBanner
                      ? _c(
                          "div",
                          { staticClass: "col-12 mobile-only" },
                          [
                            _c(
                              "q-carousel",
                              {
                                staticClass: "text-white",
                                attrs: {
                                  height: _vm.getHeight + "px",
                                  infinite: "",
                                  autoplay: ""
                                }
                              },
                              _vm._l(_vm.banners, function(banner, index) {
                                return _c("q-carousel-slide", {
                                  key: index,
                                  attrs: { "img-src": banner.image_mobile }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row gutter-md" },
                        [
                          _vm._l(_vm.filteredTrails, function(trail, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "col-xs-12 col-sm-12"
                              },
                              [
                                _vm.$q.platform.is.desktop
                                  ? _c("card-trail-desktop", {
                                      key: trail.id,
                                      attrs: { trail: trail },
                                      on: {
                                        clickLike: _vm.clickLike,
                                        clickStars: _vm.clickStars,
                                        clickFavorite: _vm.clickFavorite
                                      }
                                    })
                                  : _vm._e(),
                                _vm.$q.platform.is.mobile
                                  ? _c("card-trail-mobile", {
                                      key: trail.id,
                                      attrs: { trail: trail },
                                      on: {
                                        clickLike: _vm.clickLike,
                                        clickStars: _vm.clickStars,
                                        clickFavorite: _vm.clickFavorite
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm.filteredTrails.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c(
                                    "q-card",
                                    [
                                      _c("q-card-title", [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(_vm.$t("no_trail_found")) +
                                            "\n                                        "
                                        )
                                      ]),
                                      _c("q-card-separator"),
                                      this.search ||
                                      this.selected_areas.length > 0 ||
                                      this.favorite != "all" ||
                                      this.progress != "all" ||
                                      this.selected_groups.length > 0
                                        ? _c("q-card-main", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "searched_term_returned_no_results"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ])
                                        : _c("q-card-main", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "there_are_no_trails_avaliable_at_the_moment"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("modal-stars", {
        attrs: { show: _vm.show_modal, trail: _vm.trail },
        on: { hideModal: _vm.hideModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }